import { getSubDomain } from "@/services/helper";

async function render(props = {}) {
  //empty
}

const loader = (loading: boolean) => render({ loading });

export const subApps = [
  {
    name: 'main-sydone_3126033173977255231',
    entry: 'https://3126033173977255231.' + getSubDomain(),
    container: '#sub-main',
    loader,
    activeRule: ['/iam', '/management']
  },
  {
    name: 'iam-management_3126127733017412088',
    entry: 'https://3126127733017412088.' + getSubDomain(),
    container: '#sub-iam',
    loader,
    activeRule: ['/iam']
  },
  {
    name: 'sydone_platform',
    entry: 'https://3126033173977255197.' + getSubDomain(),
    container: '#sub-platform',
    loader,
    activeRule: ['/management']
  }
];